import React from "react";
import { FaTimes } from "react-icons/fa";
import Button from "../../../shared/buttons";
import Heading from "../../../shared/headings";
import { Container, FormDesc, Modal, ModalHead } from "./styles";

function FormWantBeVoluntary({ open, setOpen }) {
  return (
    <Container open={open}>
      <Modal>
        <ModalHead>
          <Heading text={"Quero ser um voluntário"} color={"primary"} />
          <button onClick={() => setOpen(false)}>
            <FaTimes size={28} />
          </button>
        </ModalHead>

        <FormDesc>
          <h2>
            Estamos felizes pelo seu interesse em fazer parte da nossa causa!
          </h2>

          <p>
            Para participar de nossas ações como pessoa voluntária preencha os
            dados abaixo:
          </p>
        </FormDesc>

        <form action="">
          <label htmlFor="">Nome completo: *</label>
          <input type="text" />

          <label htmlFor=""> Telefone com DDD: * </label>
          <input type="tel" name="" id="" />

          <label htmlFor="">Endereço: *</label>
          <input type="text" />

          <label htmlFor="">
            Disponibilidade (em quais dias e horários você pode se dedicar ao
            Circuito Inclusão?): *
          </label>
          <input type="text" />

          <label htmlFor="">Área desejada (como você pode nos ajudar): *</label>
          <textarea name="" id="" cols="30" rows="10"></textarea>

          <Button text={"Enviar"} size={"small"} typeButton={"primary"} />
        </form>
      </Modal>
    </Container>
  );
}

export default FormWantBeVoluntary;
